module.exports = __webpack_public_path__ + "static/WorkOS-eb03da305a3ebeb0ca475c55094ca8a0.jpg";